import { animate, group, query, stagger, style, transition, trigger } from '@angular/animations';
import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { ActivationStart, NavigationEnd, Router, RouterLink, Scroll } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { filter, map, Subject, takeUntil } from 'rxjs';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { ToolBarComponent } from './tool-bar/tool-bar.component';

@Component({
  selector: 'app-header',
  imports: [TranslateModule, RouterLink, NavBarComponent, ToolBarComponent, NavMenuComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  animations: [
    trigger('scrollOpen', [
      transition(':enter', [
        style({ height: 0, overflow: 'hidden' }),
        group([
          animate('1028ms cubic-bezier(.16,1,.3,1)', style({ height: '*' })),
          query(
            '.header__menu-item:nth-child(-n+8)',
            [
              style({ transform: 'translateY(-4px)' }),
              stagger(16, animate('220ms cubic-bezier(.2,.8,.2,1)', style({ transform: 'translateY(0)' }))),
            ],
            { optional: true }
          ),
          query('.header__menu-item', [animate('1ms', style({ transform: 'none' }))], { optional: true }),
        ]),
      ]),
      transition(':leave', [style({ overflow: 'hidden' }), animate('260ms cubic-bezier(.4,0,.2,1)', style({ height: 0 }))]),
    ]),
  ],
})
export class HeaderComponent implements OnInit, OnDestroy {
  private router = inject(Router);

  private destroy$ = new Subject<void>();

  isMenuOpen = signal<boolean>(false);

  ngOnInit() {
    this.router.events
      .pipe(
        map(event => (event instanceof Scroll ? event.routerEvent : event)),
        filter(event => event instanceof ActivationStart || event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: () => {
          this.isMenuOpen.set(false);
        },
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onToggleMenu(isMenuOpen: boolean) {
    this.isMenuOpen.set(isMenuOpen);
  }
}
